import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getLeaderBoard = async (type, mode) => {
  const params = {};
  if (type) params.type = type;
  if (mode) params.mode = mode;

  const res = await api.get(networkConfig.leaderboard.leaderboard, { params });
  return res.data;
};
